const featuredImage = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Best%20restaurants%20in%20san%20ramon.webp';

const ImageOne =  'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Bamboo%20Sushi.webp';
const ImageTwo = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Brass%20Door.webp';
const ImageThree = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Dos%20Coyotes%20Border%20Cafe.webp';
const ImageFour = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Firehouse%20No.%2037.webp';
const ImageFive = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/gianni-s-italian-bistro.webp';
const ImageSix = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Imperial%20Delight.webp'
const ImageSeven = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Katy%E2%80%99s%20Korner.webp';
const ImageEight = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/plucked-chicken-beer.webp';
const ImageNine = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/PrimaverA%20Ristorante.webp';
const ImageTen = 'https://landingpage-foodaholix-images.sfo3.cdn.digitaloceanspaces.com/blog34/Shish%20Grill.webp';

export const blogThirtyFour = {
  title: "10 Best Restaurants in San Ramon You Should Try | Foodaholix",
  featuredImage: featuredImage,
  content: [
   {
      para: [
        "<p>Discover 10 of the best restaurants in San Ramon that serve diverse and delicious cuisine from different regions and culture with Foodaholix</p>",
      ]      
    }, 
    {
      title: "",
      para: [
        "<p>San Ramon is a city in the San Francisco Bay Area with a rich history and a diverse cuisine. It was part of the land granted to Mission San Jose by the Spanish crown in the 18th century and was inhabited by the Seunen and Ohlone people. The name San Ramon comes from a local Native American leader named Ramon.</p>",
        "<p>San Ramon developed as a farming community in the 19th century, producing crops such as wheat, barley, oats, hay, and grapes. The railroad and oil discoveries boosted its growth and it became a city in 1983. Today, it is a suburban and commercial hub with over 75,000 people and several major companies.</p>",
        "<p>San Ramon also offers a variety of dining options for locals and visitors alike. Whether you are looking for a casual bite, a romantic dinner, or a family-friendly meal, you can find it in San Ramon. Here are 10 of the best restaurants in San Ramon that you should try:</p>",
      ]      
    },{
      title: "",
      shortInfo: {
        name: "Plucked Chicken & Beer",
        Address: "3191D Crow Canyon Pl, San Ramon, CA 94583",
        imageUrl: ImageEight,
      },
    },
    {
      para: [
        "<p>About Plucked Chicken & Beer </p>",
        "<p>This restaurant is a paradise for chicken lovers, as they serve up fried chicken and ice-cold beer. You can choose from a variety of menu items for big chicks and chicken littles, such as sandwiches, salads, wings, tenders, and more. They also have vegetarian and gluten-free options, such as the Beyond Meat burger and the cauliflower bites. The restaurant has a casual and fun atmosphere, with colorful decor and friendly staff. You can also enjoy live music and trivia nights on some days.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Brass Door ",
        Address: "2154 San Ramon Valley Blvd, San Ramon, CA 94583",
        imageUrl: ImageTwo,
        reverse: true,        
      },
    },
    {
      para: [
        "<p>About Brass Door :</p>",
        "<p>This restaurant and steakhouse is a San Ramon institution, as it has been serving the community since 1955. They feature USDA Choice Corn Fed Beef, Prime Rib, fresh seafood, spectacular salads, and fresh pasta. They also have a full bar with cocktails, wine, and beer. You can enjoy your meal in their cozy dining room or their outdoor patio, which has a fireplace and a fountain. The restaurant is known for its generous portions, attentive service, and classic ambiance.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Gianni’s Italian Bistro",
        Address: "2065 San Ramon Valley Blvd, San Ramon, CA 94583",
        imageUrl: ImageFive,
      },
    },
    {
      para: [
        "<p>About Gianni’s Italian Bistro: </p>",
        "<p>This family-owned and operated bistro serves contemporary food inspired by every region of Italy. They use fresh and local ingredients to create dishes such as pizza, pasta, risotto, chicken, veal, fish, and more. They also have a wine list that features Italian and Californian wines. You can enjoy your meal in their elegant dining room or their private banquet room, which can accommodate up to 60 guests. The restaurant also hosts special events such as wine dinners, cooking classes, and live music.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Firehouse No. 37:",
        Address: "250 Market Pl, San Ramon, CA 94583",
        imageUrl: ImageFour,
        reverse: true,                
      },
    },
    {
      para: [
        "<p>About Firehouse No. 37: </p>",
        "<p>This restaurant offers classic, delicious American cuisine with a twist. They have 44 types of beer on tap, including many local California beers, as well as an extensive wine and liquor list. You can enjoy your food and drink in their main restaurant, their separate bar area with 18 TVs, or their private dining spaces. They also have two big patios for outdoor seating, one of which has a fire pit and a fountain. The restaurant serves dishes such as burgers, sandwiches, salads, ribs, steaks, fish tacos, and more.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Katy’s Korner",
        Address: "2550 San Ramon Valley Blvd, San Ramon, CA 94583",
        imageUrl: ImageSeven,
      },
    },
    {
      para: [
        "<p>About Katy’s Korner: </p>",  
        "<p>This restaurant is a popular spot for breakfast and brunch in San Ramon. They serve American and Californian cuisine with dishes such as omelets, pancakes, waffles, eggs benedict, sandwiches, salads, burgers, and more. They also have a kids menu and a catering service. The restaurant has a cozy and homey feel, with wooden tables and chairs and colorful paintings on the walls. The service is friendly and fast, and the portions are large and satisfying.</p>",
      ],
    },
    {
      title: "",
      shortInfo: {
        name: "PrimaverA Ristorante:",
        Address: "3124 Crow Canyon Pl, San Ramon, CA 94583",
        imageUrl: ImageNine,
        reverse: true,        
      },
    },
    {
      para: [
        "<p>About PrimaverA Ristorante: </p>",
        "<p>This restaurant is a fine dining destination for Italian food lovers in San Ramon. They serve authentic and elegant dishes such as antipasti, insalate, zuppe, pasta, carne, pesce, and dolci. They also have a full bar with cocktails, wine, and beer. You can enjoy your meal in their sophisticated dining room or their private banquet room, which can accommodate up to 100 guests. The restaurant also offers catering services for weddings, corporate events, and other occasions. The restaurant is known for its high-quality ingredients, exquisite presentation, and impeccable service.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Dos Coyotes Border Cafe",
        Address: "3191 Crow Canyon Pl Suite L, San Ramon, CA 94583,",
        imageUrl: ImageThree,
      },
    },
    {
      para: [
        "<p>About Dos Coyotes Border Cafe: </p>",
        "<p>This restaurant serves fresh and flavorful Mexican food with a Southwestern twist. You can enjoy dishes such as burritos, tacos, enchiladas, quesadillas, nachos, salads, bowls, and more. They also have vegetarian and gluten-free options, such as the veggie burrito and the quinoa salad. The restaurant has a vibrant and colorful atmosphere, with Mexican art and music. You can also order online or use their app for takeout or delivery.</p>",
      ],
    }, {
      title: "",
      shortInfo: {
        name: "Imperial Delight",
        Address: "445 Emerson St, Palo Alto, CA 94301",
        imageUrl: ImageSix,
        reverse: true,        
      },
    },
    {
      para: [
        "<p>About Imperial Delight: </p>",
        "<p>This restaurant serves delicious Chinese cuisine with a variety of dishes such as dim sum, soup dumplings, noodles, rice, chicken, beef, pork, seafood, vegetables, and more. They also have a lunch special menu and a catering service. The restaurant has a spacious and modern dining room, with comfortable booths and tables. The service is friendly and efficient, and the food is fresh and tasty.</p>",
      ],
    },
    {
      title: "",
      shortInfo: {
        name: "Bamboo Sushi",
        Address: "6000 Bollinger Canyon Rd #2201, San Ramon, CA 94583",
        imageUrl: ImageOne,     
      },
    },
    {
      para: [
        "<p>About Bamboo Sushi: </p>",
        "<p>This restaurant serves sustainable and high-quality sushi and Japanese cuisine. You can enjoy dishes such as nigiri, sashimi, rolls, bowls, bento boxes, and more. They also have vegan and gluten-free options, such as the avocado roll and the tofu teriyaki bowl. The restaurant has a sleek and stylish interior, with bamboo accents and dim lighting. You can also order online or use their app for takeout or delivery.</p>",
      ],
    },
    {
      title: "",
      shortInfo: {
        name: "Shish Grill",
        Address: "1061 Market Pl #A, San Ramon, CA 94583",
        imageUrl: ImageTen,
        reverse: true,        
      },
    },
    {
      para: [
        "<p>About Shish Grill: </p>",
        "<p>This restaurant serves authentic and delicious Lebanese and Middle Eastern food. You can savor dishes such as hummus, falafel, shawarma, kebabs, salads, wraps, and more. They also have vegetarian and halal options, such as the veggie wrap and the lamb kebab. The restaurant has a warm and inviting atmosphere, with Mediterranean decor and music. You can also order online or use their app for takeout or delivery.</p>",
      ],
    },                      
    {
      title: "Conclusion: ",
      para: [
        "<p>In conclusion, San Ramon boasts a vibrant culinary scene with options to suit every taste. Whether you're craving comfort food, elegant Italian dishes, or exotic Middle Eastern flavors, these top 10 restaurants have something special to offer. So why wait? Embark on a culinary adventure in San Ramon today!</p>",
      ]
    },    
    {
      title: "Frequently Asked Questions (FAQ)",
      para: [
        "<p></p>"
      ]
    },
    {
      title: "Do these restaurants offer vegetarian options?",
      para: [
        "<p>A1: Yes, all of these restaurants offer a range of vegetarian dishes to cater to different dietary preferences.</p>"
      ]
    },
    {
      title: "Are reservations recommended at these restaurants?",
      para: [
        "<p>A2: It's advisable to make reservations, especially during peak hours or on weekends, to secure a table.</p>"
      ]
    },
    {
      title: "Do any of these restaurants offer outdoor seating?",
      para: [
        "<p>A3: Yes, several of these restaurants provide outdoor seating options for guests who prefer al fresco dining.</p>"
      ]
    },
    {
      title: "Do these restaurants offer takeout or delivery services?",
      para: [
        "<p>A4: Yes, most of these restaurants offer takeout and some even provide delivery services for added convenience.</p>"
      ]
    },
    {
      title: "Are these restaurants family-friendly?",
      para: [
        "<p>A5: Yes, all of the mentioned restaurants are family-friendly and offer menus suitable for children.</p>"
      ]
    },                
    {
      title: "Introducing Foodaholix",
      para: [
        "<p>Foodaholix is a social media platform designed for food lovers. It was created to help people discover new and exciting foods, and to connect with others who share a passion for great cuisine.</p>",
        "<p>Foodaholix features a number of useful tools for foodies, including a restaurant finder and an extensive database of food reviews. Users can search for restaurants by location, cuisine type, and price range, and can read reviews and ratings from other users to help them make informed dining decisions.</p>",
        "<p>So why not join the Foodaholix community today? Sign up for a free account and start exploring the world of food like never before.</p>",
      ]
    }   
  ]
}